import React from "react";
import {
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  Typography
} from "@mui/material";
import cs1 from '../assets/img/FLUDEE AI Poster.png';
import cs2 from '../assets/silde2.png';
import cs3 from '../assets/silde3.png';
import cs4 from '../assets/silde4.png';
const services = [
  {
    title: " Flagship product FLUDEE",
    description:
      "FLUDEE is a clinically driven medical technology platform designed to address critical gaps in patient monitoring, workflow efficiency, and decision support within real-world healthcare environments. Built in close alignment with clinical practice, FLUDEE focuses on reliability, usability, and evidence-based performance to support safer and more effective patient care.",
    image:cs1
     },
  {
    title: "Medical Device Engineering ",
    description:
      "Our medical device engineering is driven by clinical intent and executed with precision. We transform clearly defined clinical requirements into robust, validated prototypes by aligning engineering decisions with real-world workflows, human factors, safety constraints, and regulatory expectations. Every design choice is tested against how care is actually delivered—ensuring our devices are practical, reliable, and built for clinical adoption, not just technical performance.",
    image:cs2
      },
  {
    title: "IP & Regulatory pathway ",
    description:
      "We proactively identify and secure intellectual assets through a structured IP strategy that includes invention disclosure, patent landscape assessment, and targeted patent filings to protect core technologies, system architectures, and unique methodologies.mapping product development to applicable regulatory frameworks including CDSCO requirements and relevant ISO and IEC standards.early into design, verification, and validation activities, enabling smoother transitions from prototyping to clinical evaluation and eventual commercialization",
    image:cs3
       },
  {
    title: "Research & publications",
    description:
      "Through structured studies and transparent documentation, we contribute to the scientific ecosystem while strengthening the validation of our medical technologies.Our publications and research activities include white papers that outline system design and clinical rationale, feasibility studies that evaluate real-world performance and usability, and abstracts and posters presented at scientific and medical forums. We actively participate in conferences to share insights, gather expert feedback, and align our development with evolving clinical standards. In parallel, our ongoing research work supports continuous improvement, design refinement, and future clinical validation initiatives.",
    image:cs4
     }
];

function ServicesSection() {
  return (
    <Box sx={{ py: { xs: 6, md: 12 }, backgroundColor: "#f5f7fa" }}>
      <Container>
        {/* Heading */}
        <Typography variant="h4" align="center" fontWeight={700} gutterBottom>
        Medical Technology Built on Research and Precision
        </Typography>

        <Typography
          variant="body1"
          align="center"
          color="text.secondary"
          sx={{ maxWidth: 760, mx: "auto", mb: 6 }}
        >
        {/*  Describe the R&D philosophy, clinical- problem-first approach, TRL-based development pipeline
          design validation, prototyping ,and testing  workflow .*/}
     
        </Typography>

        {/* CENTERED CARDS */}
        <Grid
          container
          spacing={4}
          justifyContent="center"
        >
          {services.map((service, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={5}
              key={index}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Card
                sx={{
                  maxWidth: 420,
                  width: "100%",
                  borderRadius: 3,
                  overflow: "hidden",
                  transition: "0.3s ease",
                  "&:hover": {
                    transform: "translateY(-6px)",
                    boxShadow: 6
                  }
                }}
              >
                {/* Card Image */}
                <Box
                  component="img"
                  src={service.image}
                  alt={service.title}
                  sx={{
                    width: "100%",
                    height: 210,
                    objectFit: "cover"
                  }}
                />

                {/* Card Content */}
                <CardContent sx={{ p: 3, textAlign: "center" }}>
                  <Typography variant="h6" fontWeight={700} gutterBottom>
                    {service.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {service.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default ServicesSection;
